import { ContactType } from "../Components/Types"
import { api } from "./apiConfig"

export const ContactAPI = {
    post: async function (data: ContactType) {
        const apiCall = await api();
        const response = await apiCall.request({
            url: "Contact/SendContactForm",
            method: "POST",
            data
        })
        return response.data
    }
}